import { Box, Icon, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { AnswerProps } from "./types"
import { useStyles } from "./styles"

const Answer = ({ answer }: AnswerProps) => {
    const styles = useStyles()
    return (
        <Box sx={styles.comment}>
            <Icon className="color-primary">{icons('arrow-right')}</Icon>

            <Box sx={styles.commentInfo}>
                <Typography variant="subtitle_grey">{answer.date} - {answer.user}</Typography>
                <Typography variant="text_grey">{answer.comment}</Typography>
            </Box>
        </Box>
    )
}

export { Answer }